import lightBlue from '@material-ui/core/colors/lightBlue';
import purple from '@material-ui/core/colors/purple';
import orange from '@material-ui/core/colors/orange';
import { fade } from '@material-ui/core';
import { red } from '@material-ui/core/colors';

const defaultContentTheme = {
  direction: 'ltr',
  typography: {
    fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto',
    fontSize: 14,
    fontWeight: 500,
    subheading: {
      fontSize: '14px'
    },
    heading1: {
      size: 16,
      color: 'rgb(100, 100, 140)',
      weight: 600
    },
    heading2: {
      color: 'rgb(156, 156, 188)',
      size: 12,
      weight: 400
    },
  },
  palette: {
    type: 'light',
    primary: {
      // main:'#8e5dcb'
      main:'#6200ea'
    },
    // secondary: orange,
    secondary: {
      main:'#de3618'
    // main:'#f7cfbd'
    },
    success: {
      main:'#96d48a'
    },
    background: {
      default: '#FFF',
      box: 'rgb(247, 247, 255)',
      rl: 'rgb(234, 234, 244)',
      error: fade(orange[500], .6),
      button: {
        main: '#28145a',
        light: '#3d2b6a'
      },
      dockedMenu: '#2c0069'
    },
    info: lightBlue,
    error: red
  },
  status: {
    danger: 'orange'
  },
  shape: {
    borderRadius: 5
  },
  overrides: {
    MuiDialog: {
      paper: {
        maxWidth: '80%',
        margin: 0,
        padding: 0,
        borderRadius: 10,
        overflow: 'hidden',
      },
    },
    MuiAppBar: {
      colorDefault: {
        backgroundColor: '#FFF',
        color: '#000'
      }
    },
    MuiTypography: {
      h6: {
        fontSize: '1.15rem',
        fontWeight: 400
      },
      h5: {
        fontSize: 15,
        fontWeight: 500,
      },
      h4: {
        fontSize: 22,
        fontWeight: 600,
        fontFamily: "font-family: basis-bold,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Helvetica,Arial,sans-serif"
      },
      body1: {
        fontSize: 14,
        color:"#5E5F5F",
        fontWeight: 600,
        fill: 'rgb(156, 156, 188)',
        outlineColor: 'rgb(156, 156, 188)',
        textDecorationColor: 'rgb(156, 156, 188)',
      },
      body2: {
        fontSize: 14,
        color: 'rgb(156, 156, 188)',
        fontWeight: 600,
        fill: 'rgb(156, 156, 188)',
        outlineColor: 'rgb(156, 156, 188)',
        textDecorationColor: 'rgb(156, 156, 188)',
      },
      subtitle1: {
        fontSize: 14,
        color: 'rgb(100, 100, 140)',
        fontWeight: 500,
        fill: 'rgb(100, 100, 140)',
        outlineColor: 'rgb(100, 100, 140)',
        textDecorationColor: 'rgb(100, 100, 140)'
      },
      subtitle2: {
        fontSize: 12,
        color: 'rgb(100, 100, 140)',
        fontWeight: 400,
        fill: 'rgb(100, 100, 140)',
        outlineColor: 'rgb(100, 100, 140)',
        textDecorationColor: 'rgb(100, 100, 140)'
      }
    },
    MuiExpansionPanel: {
        root: {
            margin: '16px 0'
        }
    },
    MuiExpansionPanelSummary: {
      root: {
        backgroundColor: 'rgb(247, 247, 255)'
      }
    },
    MuiExpansionPanelActions: {
        root: {
            padding: '16px 24px'
        },
    },
    MuiFormLabel: {
      root: {
        fontSize: 12,
        fontWeight: 400,
        fontFamily: '-apple-system, "system-ui", "Segoe UI", Roboto'
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 4,
        '&:hover': {
          borderColor: purple[500]
        }
      },
      input:{
        padding:'12px 12px'
      }
    },
    MuiInputLabel:{
      outlined:{
        transform: 'translate(14px, 14px) scale(1)',
        fontSize:'15px'
      }
    },
    MuiGrid:{
      root:{
        padding:'6px'
      }
    },
    MuiButton: {
      root: {
        padding:'4px 14px',
        borderRadius: 4,
        textTransform: "none",
      },
      outlinedPrimary: {
        '&:hover': {
          backgroundColor: purple[500],
          color: 'white'
        }
      },
      containedPrimary: {
        color: 'white'
      }

    },
    MuiIconButton: {
      sizeSmall: {
        padding: 8
      },
      root: {
        '&:hover': {
          backgroundColor: fade(purple[500], .08),
          '& svg':{
            fill:purple[500]
          }
        }
      }
    },
    MuiPaper: {
      elevation1: {
        boxShadow: '0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)'
      },
      rounded: {
        borderRadius: 10
      }
    },
    MuiTableCell: {
      root: {
        fontSize: 12,
        fontWeight: 400
      },
      head: {
          fontWeight: 600
      }
    }
  },
  dialog: {
    borderRadius: '10px'
  }
};



const themes = [
  {
    id: 'classic-revrec',
    name: 'Classic - RevRec',
    theme: {
      contentTheme: defaultContentTheme,
      sidenavTheme: defaultContentTheme
    }
  }
];

export default themes;
